var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP2PDispute({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "p2p_dispute",
    transform: "translate(299 -8211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verify_acc",
    transform: "translate(-219 83)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149",
    "data-name": "Rectangle 2149",
    width: 64,
    height: 64,
    transform: "translate(-80 8128)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e5624d39b35c645fcb2dc242597966b6",
    transform: "translate(-77.942 8130.059)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2150",
    "data-name": "Rectangle 2150",
    width: 60,
    height: 60,
    rx: 5.917,
    transform: "translate(-0.058 -0.058)",
    fill: "#017f99"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_13a1e2949bdaeae3634e581153631d55",
    "data-name": "13a1e2949bdaeae3634e581153631d55",
    transform: "translate(11.498 11.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24657",
    "data-name": "Path 24657",
    d: "M6.391,25.667l-2.251-1.6a.563.563,0,0,0-.653,0l-2.251,1.6A.563.563,0,0,0,1,26.128v2.408A.563.563,0,0,0,1.236,29l2.251,1.6a.529.529,0,0,0,.326.129.6.6,0,0,0,.259-.062l.068-.045h0l2.251-1.6a.563.563,0,0,0,.236-.461V26.151A.563.563,0,0,0,6.391,25.667Zm-3.14,3.41-1.125-.8v-1.03l1.125.8Zm.563-2.009-1.283-.917,1.283-.917,1.283.917Zm1.688,1.2-1.125.8v-1.03l1.125-.8Zm.889,5.835L4.14,32.5a.563.563,0,0,0-.653,0l-2.251,1.6A.563.563,0,0,0,1,34.569v2.408a.563.563,0,0,0,.236.461l2.251,1.6a.529.529,0,0,0,.326.129.6.6,0,0,0,.259-.062l.068-.045h0l2.251-1.6A.563.563,0,0,0,6.627,37V34.591A.563.563,0,0,0,6.391,34.107Zm-3.14,3.41-1.125-.8v-1.03l1.125.8Zm.563-2.009-1.283-.917,1.283-.917,1.283.917Zm1.688,1.2-1.125.8v-1.03l1.125-.8ZM20.436,11.3l-.4-.394.793-.8-.793-.793-.8.793-.394-.394L17.65,8.51l-.8.8.8.793-1.2,1.193-1.193,1.2-.793-.8-.8.8,1.2,1.193.394.394-.793.8.793.793.8-.793.394.4-.793.822.793.793.8-.793a1.688,1.688,0,0,0,2.386,0,1.643,1.643,0,0,0,.5-1.125,1.643,1.643,0,0,0,1.125-.484,1.688,1.688,0,0,0,0-2.386l.793-.8-.793-.8Zm-1.592,3.984a.563.563,0,0,1-.8,0l-1.986-1.992.793-.793,1.992,1.986a.563.563,0,0,1,0,.8Zm1.587-1.592a.563.563,0,0,1-.793,0L17.65,11.695l.793-.793,1.992,1.986a.563.563,0,0,1-.006.8Z",
    transform: "translate(0 -3.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24658",
    "data-name": "Path 24658",
    d: "M34.006,10a9,9,0,1,0-9,9A9,9,0,0,0,34.006,10Zm-1.125,0a7.81,7.81,0,0,1-.405,2.47l-1.041-.433a6.752,6.752,0,0,0,0-4.1L32.482,7.5a7.962,7.962,0,0,1,.4,2.5ZM28.514,2.958a7.934,7.934,0,0,1,3.517,3.506L31,6.9A6.623,6.623,0,0,0,28.087,4ZM25,2.125a7.81,7.81,0,0,1,2.47.405L27.04,3.572a6.752,6.752,0,0,0-4.1,0L22.5,2.525a7.962,7.962,0,0,1,2.5-.4Zm-3.539.85L21.9,4.01A6.623,6.623,0,0,0,19,6.92l-1.041-.428a7.934,7.934,0,0,1,3.506-3.517ZM17.125,10a7.81,7.81,0,0,1,.405-2.47l1.041.433a6.752,6.752,0,0,0,0,4.1l-1.047.433a7.962,7.962,0,0,1-.4-2.5Zm11.417,7.028L27.9,15.5l-1.035.433L27.5,17.47a7.962,7.962,0,0,1-2.5.411,7.81,7.81,0,0,1-2.47-.405l.636-1.536-1.041-.428-.636,1.536a7.934,7.934,0,0,1-3.517-3.506l1.035-.433A6.786,6.786,0,0,0,20.226,14.8l.8-.8a5.627,5.627,0,1,1,7.957,0l.8.8a6.8,6.8,0,0,0,1.227-1.688l1.041.428a7.934,7.934,0,0,1-3.506,3.494Z",
    transform: "translate(-6.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_384",
    "data-name": "Ellipse 384",
    cx: 0.563,
    cy: 0.563,
    r: 0.563,
    transform: "translate(17.881 15.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2152",
    "data-name": "Rectangle 2152",
    width: 9.849,
    height: 1.407,
    transform: "translate(8.035 22.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2153",
    "data-name": "Rectangle 2153",
    width: 4.221,
    height: 1.407,
    transform: "translate(8.035 24.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2154",
    "data-name": "Rectangle 2154",
    width: 1.407,
    height: 1.407,
    transform: "translate(13.663 24.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2155",
    "data-name": "Rectangle 2155",
    width: 9.849,
    height: 1.407,
    transform: "translate(8.035 30.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2156",
    "data-name": "Rectangle 2156",
    width: 4.221,
    height: 1.407,
    transform: "translate(8.035 33.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2157",
    "data-name": "Rectangle 2157",
    width: 1.407,
    height: 1.407,
    transform: "translate(13.663 33.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24659",
    "data-name": "Path 24659",
    d: "M49.756,36H34.563a.563.563,0,0,0-.563.563V50.63a.563.563,0,0,0,.563.563H49.756a.563.563,0,0,0,.563-.563V36.563A.563.563,0,0,0,49.756,36ZM45.884,49.826a7.135,7.135,0,0,0-.636-2.813l-1.024.473a6,6,0,0,1,.563,2.577h-5.16a6,6,0,0,1,.563-2.577l-1.024-.473a7.1,7.1,0,0,0-.63,2.881,2.217,2.217,0,0,1-.923-1.407,4.569,4.569,0,0,1,3.016-4.018h0a3.061,3.061,0,0,0,3.044,0h0a4.58,4.58,0,0,1,3.022,3.99A2.127,2.127,0,0,1,45.884,49.826ZM40.19,41.785a1.969,1.969,0,1,1,1.969,1.969A1.969,1.969,0,0,1,40.19,41.785Zm9,8.283H47.2a2.965,2.965,0,0,0,.636-1.542v-.1a5.661,5.661,0,0,0-3.219-4.783,3.1,3.1,0,1,0-4.924,0,5.711,5.711,0,0,0-3.213,4.834v.079a2.932,2.932,0,0,0,.625,1.508H35.125V37.125H49.193Z",
    transform: "translate(-14.431 -15.305)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2PDispute);
export default __webpack_public_path__ + "static/media/p2p_dispute.ed511e24bd101c9ff8a2f12181fddfa4.svg";
export { ForwardRef as ReactComponent };